<template>
  <b-card class="text-secondary">
    <img v-if="giftCardImage" :src="giftCardImage" class="mb-4 rounded">

    <div v-if="to.name" class="mb-1">
      <strong>{{ to.name }},</strong>
    </div>
    {{ message }}
    <div v-if="from.name" class="mt-3">
      <strong>{{ from.name }}</strong>
    </div>
    <hr>
    <h3 v-if="card.amount" class="font-semibold text-xl mt-6 mb-6">
      {{ $site.location.currencySymbol }}{{ amount }}
    </h3>
    <h6 class="text-xs font-weight-light mb-2">
      {{ $t('pages.gift.card.index.locationGiftCard',{location: $site.location.title}) }}
    </h6>

    <small v-if="deliveryDate" class="text-xs">
      {{ $t('general.deliveredOn') }}: {{ $format.date(deliveryDate.getTime() / 1000, 'local') }}
    </small>
  </b-card>
</template>

<script setup lang="ts">
/* export default {
  filters: {
    currency (amount) {
      return parseInt(amount).toLocaleString()
    }
  },
  computed: {
    card () {
      return this.$store.getters['gift/card']
    },
    to () {
      return this.$store.getters['gift/to']
    },
    from () {
      return this.$store.getters['gift/from']
    },
    message () {
      return this.$store.getters['gift/message']
    },
    deliveryDate () {
      return this.$store.getters['gift/deliveryDate']
    },
    giftCardImage () {
      if (this.card.image) {
        const giftCardImage = this.$site.tabs.getGiftCardImage(this.card.image)

        if (giftCardImage) {
          return giftCardImage.images.large
        }
      }

      if (this.$site.images.giftCard) {
        return this.$site.images.giftCard.large
      }
      return null
    }
  }
} */

const { $site } = useNuxtApp()

const giftStore = useGiftStore()

const card = computed(() => giftStore.card)
const to = computed(() => giftStore.to)
const from = computed(() => giftStore.from)
const message = computed(() => giftStore.message)
const deliveryDate = computed(() => giftStore.deliveryDate)

const giftCardImage = computed(() => {
  if (card.value.image) {
    const giftCardImage = $site.tabs.getGiftCardImage(card.value.image)

    if (giftCardImage) {
      return giftCardImage.images.large
    }
  }

  if ($site.images.giftCard) {
    return $site.images.giftCard.large
  }
  return null
})

const amount = computed(() => {
  return card.value?.amount ? parseInt(card.value.amount).toLocaleString() : ''
})
</script>
